<app-project-item  *ngFor="let item of list" [project]="item" (onConfig)="EditConfig($event)" (onLaunch)="LaunchMap($event)"></app-project-item>
